export default "__VITE_PUBLIC_ASSET__01635c76__"